module.exports = __webpack_public_path__ + "static/img/userBanner.338dc3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/userBanner.png
// module id = XFex
// module chunks = 1